import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../features/external-api/redux/actions';
import ExternalApiHeaderNav from './ExternalApiHeaderNav';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ExternalApiList from './ExternalApiList';
import { DIRECTUS } from 'drapcode-constant';
import { checkExternalAPIPermission } from '../../common/utils/permissions';
import PermissionDenied from '../../common/PermissionDenied';
export class Directus extends Component {
  static propTypes = {
    externalApi: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = { page: 0, searchTerm: '', limit: 25, headers: [] };
  componentDidMount = async () => {
    const { match, actions, home } = this.props;
    const { projectId, version } = match.params;
    await actions.loadCollections({ projectId, version });
    await actions.loadExternalApis({
      projectId,
      version,
      page: this.state.page,
      externalApiType: DIRECTUS,
      limit: this.state.limit,
    });
    const externalapi = await actions.loadExternalDatabase({ projectId, version });
    if (externalapi) {
      const dataTypes = [...new Set(externalapi.map((item) => item.type))];
      this.setState({ headers: dataTypes });
    }
  };
  render() {
    const isAllowed = checkExternalAPIPermission();
    if (!isAllowed) {
      return <PermissionDenied message="Directus" />;
    }
    const { match } = this.props;
    const { projectId, version } = match.params;
    const { headers } = this.state;
    return (
      <CommonPageComponent>
        <ExternalApiHeaderNav
          activeTab={DIRECTUS}
          projectId={projectId}
          headers={headers}
          version={version}
        />
        <ExternalApiList projectId={projectId} activeTab={DIRECTUS} version={version} />
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    externalApi: state.externalapi,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Directus);
